import autosize from 'autosize';

export default {
  autosize: autosize
};